
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import apiUrl from "../../environment/Api";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import "../../assets/css/EnquiryReport.css";

function StaffReport() {
  const { id } = useParams();
  const [filtered, setFiltered] = useState([]);
  const [courses, setCourses] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [branch, setbranch] = useState([])
  const [Branches, setselectBranch] = useState([])
  const [loading, setLoading] = useState(false);

  const [selectedtype, setselectedtype] = useState("Info");

  const [dailytask_data, setdailytask_data] = useState([]);

  const [dailytask_staff, setdailytask_staff] = useState([]);

  const [dailytask_status, setdailytask_staus] = useState([]);

  const [unique_staff_data, setunique_staff_data] = useState([]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const leadsResponse = await axios.get(apiUrl + "/staff");
        setFiltered(leadsResponse.data);

        const branchresponse = await axios.get(apiUrl + "/branch");
        console.log("Branch response:", branchresponse.data);


        if (Array.isArray(branchresponse.data)) {
          setbranch(branchresponse.data);
        } else {
          console.error("Unexpected data format:", branchresponse.data);
        }


        const uniqueStatuses = Array.from(
          new Set(leadsResponse.data.map((item) => item.status))
        ).map((status) => ({ status: status }));

        setStatuses(uniqueStatuses);

        // Fetch courses
        const coursesResponse = await axios.get(apiUrl + "/courseinfo");
        console.log("Courses fetched:", coursesResponse.data); // Debug log
        setCourses(coursesResponse.data); // Set courses

        // =============== code to get the task data =====================
        const branchId = localStorage.getItem("branch_id");
        const dailytask_data = await axios.get(apiUrl + "/dailytask", {
          params: { data: branchId },
        });

        // console.log("The dailytask_data from the server is : ",dailytask_data.data);
        // console.log("The dailytask_data from the server is, isarray : ",Array.isArray(dailytask_data.data));

        setdailytask_data(dailytask_data.data);
        // =============== code to get the task data =====================

        // ============== code to store the unique staff data ==============
        const unique_staff_data = dailytask_data.data.reduce((acc, item) => {
          if (!acc.some((obj) => obj.staff_id === item.staff_id)) {
            acc.push(item);
          }
          return acc;
        }, []);

        console.log("the unique_staff_data is  : ", unique_staff_data);

        setunique_staff_data(unique_staff_data);
        // ============== code to store the unique staff data ==============

      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setTimeout(
        () => {
          setLoading(false)
        }, 500
      )

    };


    fetchData();
  }, [id]);

  // const formatDatefitching = (date) => {
  //   const options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(date).toLocaleDateString(undefined, options);
  // };

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  const filteredData = filtered.filter((item) => {
    console.log(item.name, item.mobile); // Check if these fields match
    const isSearchMatch = searchTerm
      ? item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(item.mobile).includes(searchTerm) ||
      item.empid.toLowerCase().includes(searchTerm.toLowerCase()) ||

      item.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.designation[0]?.designation
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||

      // Handling array for designation
      item.branch_id[0]?.branch_name
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) // Handling nested branch_id
      : true;

    const isCourseMatch = selectedCourse
      ? item.course_name.toLowerCase().includes(selectedCourse.toLowerCase())
      : true;

    const isBranchMatch = Branches
      ? item.branch_id[0]?.branch_name === Branches
      : true;

    const isStatusMatch = selectedStatus
      ? item.status
        .toLowerCase()
        .includes(selectedStatus.toLowerCase())
      : true;

    const itemEnquiryDate = new Date(item.join_date);
    const isFromDateMatch = fromDate
      ? itemEnquiryDate >= new Date(fromDate)
      : true;
    const isToDateMatch = toDate ? itemEnquiryDate <= new Date(toDate) : true;

    return isSearchMatch && isCourseMatch && isStatusMatch && isBranchMatch && isFromDateMatch && isToDateMatch;
    // return isCourseMatch && isStatusMatch && isBranchMatch&&isFromDateMatch&& isToDateMatch;

  });

  console.log(filteredData); // Check filtered data

  const currentEntries = filteredData.slice(
    indexOfFirstEntry,
    indexOfLastEntry
  );


  // code for daily task data 
  const dailytask_filteredData = dailytask_data.filter((item) => {
    console.log(item.name, item.mobile); // Check if these fields match

    const isSearchMatch = searchTerm
      ? String(item.staff_name).toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.Description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.staff_id.toLowerCase().includes(searchTerm.toLowerCase()) ||

      item.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.notes.toLowerCase().includes(searchTerm.toLowerCase()) ||

      // item.designation[0]?.designation
      //   ?.toLowerCase()
      //   .includes(searchTerm.toLowerCase()) ||

      // Handling array for designation
      item.branch_id?.branch_name
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) // Handling nested branch_id
      : true;

    const isCourseMatch = selectedCourse
      ? item.course_name.toLowerCase().includes(selectedCourse.toLowerCase())
      : true;

    const isBranchMatch = Branches
      ? item.branch_id?.branch_name === Branches
      : true;

    // old status match code  
    // const isStatusMatch = selectedStatus
    //   ? item.status
    //     .toLowerCase()
    //     .includes(selectedStatus.toLowerCase())
    //   : true;

    const itemEnquiryDate = new Date(item.date);
    const isFromDateMatch = fromDate
      ? itemEnquiryDate >= new Date(fromDate)
      : true;
    const isToDateMatch = toDate ? itemEnquiryDate <= new Date(toDate) : true;


    const isStaffMatch = dailytask_staff
      ? item.staff_id === dailytask_staff
      : true;

    const isStatusMatch = dailytask_status
      ? item.status === dailytask_status
      : true;

    return isSearchMatch && isCourseMatch && isStatusMatch && isBranchMatch && isFromDateMatch && isToDateMatch && isStaffMatch;
    // return isCourseMatch && isStatusMatch && isBranchMatch&&isFromDateMatch&& isToDateMatch && isStaffMatch;

  });

  // const dailytask_filteredData = dailytask_data.filter((item) => item.branch_id.branch_name == "Chennai");

  const dailytask_currentEntries = dailytask_filteredData.slice(
    indexOfFirstEntry,
    indexOfLastEntry
  );

  // ============== code to generate the seperate list for unique status =====================
  const uniqueStatuses = [...new Set(dailytask_data.map((item) => item.status))];

  // console.log("The uniqueStatuses is : ",uniqueStatuses);
  // ============== code to generate the seperate list for unique status =====================


  // console.log("this is the console after the filter list : ",Array.isArray(dailytask_data));

  const handleEntriesPerPageChange = (event) => {
    setEntriesPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
    setCurrentPage(1);
  };

  const handleBranchChange = (event) => {
    setselectBranch(event.target.value);
    setCurrentPage(1);

    // console.log("The event.target.value in the handleBranchChange is : ",event.target.value);
    // console.log("The event.target.value == '' in the handleBranchChange is : ",event.target.value  == "");

    if (event.target.value == "") {
      const unique_staff_data = dailytask_data.reduce((acc, item) => {
        if (!acc.some((obj) => obj.staff_id === item.staff_id)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setunique_staff_data(unique_staff_data);
    }
    else {
      let unique_staff_data = dailytask_data.filter(
        (item) => item.branch_id?.branch_name.trim().toLowerCase() === event.target.value.trim().toLowerCase()
      );

      unique_staff_data = unique_staff_data.reduce((acc, item) => {
        if (!acc.some((obj) => obj.staff_id === item.staff_id)) {
          acc.push(item);
        }
        return acc;
      }, []);

      setunique_staff_data(unique_staff_data);
    }
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
    setCurrentPage(1);
  };

  const handleSelectedtypeChange = (event) => {
    setselectedtype(event.target.value);
    setCurrentPage(1);
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    handleClearFilters();
  }, []);

  const handleClearFilters = () => {
    setSelectedCourse("");
    setSelectedStatus("");
    setselectBranch("");
    setFromDate("");
    setToDate("");
    setSearchTerm("");
    setCurrentPage(1);
    // setselectedtype("Info");
    setdailytask_staff("");
    setdailytask_staus("");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handleCopy = () => {
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      const tableData = tableElement.innerText;
      navigator.clipboard
        .writeText(tableData)
        .then(() => {
          alert("Staff Table data copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      console.error("Table with ID 'tableId' not found");
    }
  };

  const handleCSVExport = () => {
    const csvHeaders = [
      "S.No",
      "branch",
      "Type",
      "Date",
      "Notes",
      "Amount",
      "From",
      "To",
      "Paytype",
    ];
    const csvData = filteredData.map((item, index) => [
      index + 1,
      item.branch_id,
      item.type,
      formatDate(item.join_date),
      item.notes,
      item.amount,
      item.from,
      item.to,

      item.paytype,
    ]);

    const csvContent = [
      csvHeaders.join(","), // Headers
      ...csvData.map((row) => row.join(",")), // Data rows
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "Staff_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = () => {
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      const worksheet = XLSX.utils.table_to_sheet(tableElement);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "Staff_Report.xlsx");
    } else {
      console.error(
        "Table with ID 'tableId' not found. Check if the table is rendered in the DOM."
      );
    }
  };

 
  // const handleGeneratePDF = () => {
  //   const tableElement = document.getElementById("tableId");
  //   if (!tableElement) {
  //     console.error("Table with ID 'tableId' not found");
  //     return;
  //   }

  //   html2canvas(tableElement)
  //     .then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");
  //       const pdf = new jsPDF();

  //       // Add the title text at the top of the PDF
  //       pdf.setFontSize(26);
  //       pdf.text("Staff Report", 20, 20); // Adjust x and y position as needed

  //       // Add the table image below the title
  //       pdf.addImage(imgData, "PNG", 10, 30, 190, 0); // Adjust the y position for image accordingly

  //       // Save the PDF
  //       pdf.save("Staff_report.pdf");
  //     })
  //     .catch((error) => {
  //       console.error("Error generating PDF: ", error);
  //     });
  // };

  const handleGeneratePDF = () => {
    const tableElement = document.getElementById("tableId");
    if (!tableElement) {
      console.error("Table with ID 'tableId' not found");
      return;
    }
  
    html2canvas(tableElement, { scale: 2, useCORS: true }).then((canvas) => {
      const pdf = new jsPDF("p", "mm", "a4"); // A4 size in portrait
      const pageWidth = pdf.internal.pageSize.width;
      const pageHeight = pdf.internal.pageSize.height;
  
      const imgWidth = 190; // Max image width
      let imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
  
      let positionY = 30; // Start below the title
      let sourceY = 0;
      let remainingHeight = imgHeight;
  
      //  Add Title on First Page
      pdf.setFontSize(23);
      pdf.text("Staff Report", 20, 20);
  
      while (remainingHeight > 0) {
        const cropHeight = Math.min(pageHeight - 40, remainingHeight); // Adjust margins
        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvas.width;
        pageCanvas.height = (cropHeight * canvas.width) / imgWidth;
  
        const ctx = pageCanvas.getContext("2d");
        ctx.drawImage(
          canvas,
          0, sourceY, canvas.width, pageCanvas.height, // Crop source
          0, 0, pageCanvas.width, pageCanvas.height // Destination
        );
  
        //  Use **JPEG (Better Compression & Quality)**
        const croppedImg = pageCanvas.toDataURL("image/jpeg", 0.95);
        pdf.addImage(croppedImg, "JPEG", 10, positionY, imgWidth, cropHeight);
  
        remainingHeight -= cropHeight;
        sourceY += pageCanvas.height;
  
        if (remainingHeight > 0) {
          pdf.addPage();
          positionY = 10; // Reset for new page
        }
      }
  
      //  **Calculate File Size (KB) Before Saving**
      const pdfBlob = pdf.output("blob");
      const fileSizeKB = Math.round(pdfBlob.size / 1024);
      console.log(`Estimated PDF file size: ${fileSizeKB} KB`);
  
      pdf.save("Staff_Report.pdf");
    }).catch((error) => {
      console.error("Error generating PDF: ", error);
    });
  };
  
  




  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      printWindow.document.write(`
            <html>
              <head>
                <title>Print Staff Table</title>
                <style>
                  table { width: 100%; border-collapse: collapse; }
                  th, td { border: 1px solid #000; padding: 8px; text-align: left; }
                  th { background-color: #f2f2f2; }
                </style>
              </head>
              <body>
                <h1>Staff  Report</h1>
                <div>${tableElement.outerHTML}</div>
              </body>
            </html>
          `);
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Table with ID 'tableId' not found");
    }
  };




  useEffect(() => {
    gettoken();
    getprevillages();
  }, []);


  const gettoken = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);

      setroleid(response.data.detail.rolename);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      if (id) { }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);
    const total_previlages = username.modules;
    const new_enquiry = total_previlages.find((item) => item.name == "Staff Report")
    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions)
  }




  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };



  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  const createPagination = () => {
    let liTag = [];
    let beforePage = currentPage - 1;
    let afterPage = currentPage + 1;
    let active;

    if (currentPage > 1) {
      liTag.push(
        <li className="page-item" key="prev">
          <button
            className="page-link"
            onClick={() => paginate(currentPage - 1)}
          >
            <FaAngleLeft /> Prev
          </button>
        </li>
      );
    }

    if (currentPage > 2) {
      liTag.push(
        <li className="page-item" key="first" onClick={() => paginate(1)}>
          <button className="page-link">1</button>
        </li>
      );
      if (currentPage > 3) {
        liTag.push(
          <li className="page-item disabled" key="dots1">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    if (currentPage === totalPages) {
      beforePage -= 2;
    } else if (currentPage === totalPages - 1) {
      beforePage -= 1;
    }

    if (currentPage === 1) {
      afterPage += 2;
    } else if (currentPage === 2) {
      afterPage += 1;
    }

    for (let plength = beforePage; plength <= afterPage; plength++) {
      if (plength > totalPages || plength <= 0) continue;
      active = currentPage === plength ? "active" : "";
      liTag.push(
        <li
          className={`page-item ${active}`}
          key={plength}
          onClick={() => paginate(plength)}
        >
          <button className="page-link">{plength}</button>
        </li>
      );
    }

    if (currentPage < totalPages - 1) {
      if (currentPage < totalPages - 2) {
        liTag.push(
          <li className="page-item disabled" key="dots2">
            <span className="page-link">...</span>
          </li>
        );
      }
      liTag.push(
        <li
          className="page-item"
          key="last"
          onClick={() => paginate(totalPages)}
        >
          <button className="page-link">{totalPages}</button>
        </li>
      );
    }

    if (currentPage < totalPages) {
      liTag.push(
        <li className="page-item" key="next">
          <button
            className="page-link"
            onClick={() => paginate(currentPage + 1)}
          >
            Next <FaAngleRight />
          </button>
        </li>
      );
    }

    return liTag;
  };

  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="container-fluid" style={{ backgroundColor: "#E8EFF9" }}>
        <div
          className="card p-2"
          style={{
            marginTop: "-80px",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
        >
          <div className="row">
            <h6 className="mt-3" style={{color:"#8f0505"}}>
              <b>Staff Report</b>
            </h6>
          </div>
          <hr />
          <div className="row p-2">
            <div className="col-lg-2 col-md-3 col-sm-12 mx-3">
              <input
                type="date"
                value={fromDate}
                onChange={handleFromDateChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12">
              <input
                type="date"
                value={toDate}
                onChange={handleToDateChange}
                className="form-control"
              />
            </div>


            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={Branches} // Ensure this matches the state variable for the selected branch
                // onChange={(e) => setselectBranch(e.target.value)} // Update the state
                onChange={handleBranchChange}
                className="form-control"
              >
                <option value="">All Branches</option>
                {branch.map((branchItem) => (
                  <option key={branchItem._id} value={branchItem.branch_id?.branch_name}>
                    {branchItem.branch_name}
                  </option>
                ))}
              </select>
            </div>

            {/* <div className="col-lg-2 col-md-3 col-sm-12">
            <select
              value={selectedCourse}
              onChange={handleCourseChange}
              className="form-control"
            >
              <option value="">Select Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.course_name}>
                  {course.course_name}
                </option>
              ))}
            </select>
          </div> */}
            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={selectedStatus}
                onChange={handleStatusChange}
                className="form-control"
                disabled={selectedtype === "Task"}
              >
                <option value="">Select Status</option>
                {statuses.map((status, index) => (
                  <option key={index} value={status.status}>
                    {status.status}
                  </option>
                ))}
              </select>
            </div>

            {/* code for new dropdown */}
            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={selectedtype}
                onChange={handleSelectedtypeChange}
                className="form-control"
              >
                {/* <option value="">Select Status</option> */}
                {/* {statuses.map((status, index) => (
                <option key={index} value={status.status}>
                  {status.status}
                </option>
              ))} */}
                <option value="Info">Info</option>
                <option value="Task">Task</option>
              </select>
            </div>

            <div className="col-lg-1 col-md-2 col-sm-12">
              <button className="btn btn-danger" onClick={handleClearFilters}>
                Clear
              </button>
            </div>

            {/* === code for staff and status filter for dailytask table === */}
            {selectedtype === "Task" && (
              <div className="col-lg-2 col-md-3 col-sm-12" style={{ marginTop: '10px', marginLeft: '15px' }}>
                <select
                  value={dailytask_staff} // Ensure this matches the state variable for the selected branch
                  onChange={(e) => setdailytask_staff(e.target.value)} // Update the state
                  className="form-control"
                >
                  <option value="">All Staffs</option>
                  {/* {dailytask_data
              .filter((item, index) => index !== 0 && item.staff_id && item.staff_name) // Skip first item & invalid data
              .map((item) => (
                <option key={item.staff_id} value={item.staff_id}>
                  {item.staff_name}
                </option>
              ))} */}
                  {unique_staff_data
                    .filter((item, index) => index !== 0 && item.staff_id && item.staff_name) // Skip first item & invalid data
                    .map((item) => (
                      <option key={item.staff_id} value={item.staff_id}>
                        {item.staff_name}
                      </option>
                    ))}
                </select>
              </div>
            )}

            {selectedtype === "Task" && (
              <div className="col-lg-2 col-md-3 col-sm-12" style={{ marginTop: '10px', marginLeft: '15px' }}>
                <select
                  value={dailytask_status} // Ensure this matches the state variable for the selected branch
                  onChange={(e) => setdailytask_staus(e.target.value)} // Update the state
                  className="form-control"
                >
                  <option value="">All Status</option>
                  {uniqueStatuses.map((status, index) => (
                    <option key={index} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {/* === code for staff and status filter for dailytask table === */}
          </div>
          <hr />
          <div className="row">
            <div className="col-md-3 d-flex align-items-center">
              <p className="mb-0 mr-2">Show </p>
              <select
                value={entriesPerPage}
                onChange={handleEntriesPerPageChange}
                className="form-control mx-2"
                style={{ width: "50px" }}
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={filteredData.length}>All</option>
              </select>
            </div>

            <div className="col-md-6">
              {previllages.download && (
                <button className="btn btn-secondary2 mx-2" onClick={handleCopy}>
                  Copy
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-success2 mx-2" onClick={handleCSVExport}>
                  CSV
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-excel2 mx-2" onClick={handleExport}>
                  Excel
                </button>
              )}

              {previllages.download && (
                <button className="btn btn-info2 mx-2" onClick={handleGeneratePDF}>
                  PDF
                </button>)}

              {previllages.download && (
                <button className="btn btn-warning2 mx-2" onClick={handlePrint}>
                  Print
                </button>
              )}
            </div>

            <div className="col-md-3 d-flex align-items-center">
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
                className="form-control"
              />
            </div>
          </div>

          {selectedtype === "Info" && (
            <table id="tableId" className="table table-striped table-bordered mt-2">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Branch</th>
                  <th>Empid</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Designation</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {currentEntries.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1 + (currentPage - 1) * entriesPerPage}</td>
                    <td>{item.branch_id[0]?.branch_name}</td>
                    <td>{item.empid}</td>
                    <td>{item.name}</td>
                    <td>{item.mobile}</td>
                    {/* <td>{item.designation? item.designation[0].designation : "-"}</td> */}
                    <td>{item.designation[0] ? item.designation[0].designation : "-"}</td>
                    <td>{formatDate(item.join_date)}</td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {selectedtype === "Task" && (
            <table id="tableId" className="table table-striped table-bordered mt-2">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Branch</th>
                  <th>Staff Id</th>
                  <th>Staff Name</th>
                  <th>Description</th>
                  <th>Notes</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {/* {currentEntries.map((item, index) => ( */}
                {dailytask_currentEntries.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1 + (currentPage - 1) * entriesPerPage}</td>
                    <td>{item.branch_id?.branch_name}</td>
                    <td>{item.staff_id}</td>
                    <td>{item.staff_name}</td>
                    <td>{item.Description}</td>
                    {/* <td>{item.designation? item.designation[0].designation : "-"}</td> */}
                    <td>{item.notes}</td>
                    <td>{formatDate(item.date)}</td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          <div className="row">
            <div className="col-lg-4">
              <div className="dataTables_info" role="status" aria-live="polite">
                Showing {indexOfFirstEntry + 1} to{" "}
                {Math.min(indexOfLastEntry, filtered.length)} of {filtered.length}{" "}
                entries
              </div>
            </div>
            <div className="col-lg-5"></div>
            <div className="row">
              <div className="mt-3 pb-5">
                <div className="row">
                  <div className="col-lg-7 col-sm-12 mt-1">
                    <span className="text-dark">
                      Page {currentPage} of {totalPages}
                    </span>
                  </div>
                  <div className="col-lg-5">
                    <nav>
                      <ul className="pagination justify-content-center">
                        {createPagination()}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StaffReport;
